<app-nav></app-nav>
<section class="aboutUs">
    <div class="container">
    
      <div class="col-md-auto">

      <div class="page_progress">
        <h5 class="comments_dash">Claim Status</h5>
        <ul class="StepProgress step_height" id="progressBarofEclaims">
          <li class="StepProgress-item" [ngClass]="{'is-done' : isClaimIntimated}"><strong> {{Claim_Intimated}} </strong> 
            
          <p class="date1">{{this.intimatedDate | date: 'dd/MM/yyyy'}}</p>
          
          </li>

          <li class="StepProgress-item" [ngClass]="{'is-done' : isAcknowledgedByinsurer}"><strong>{{ Acknowledged }}</strong>
            <p class="date1">{{this.dateByinsurer | date: 'dd/MM/yyyy'}}</p>
             <button type="button" class="Path-8998 btn btn-primary" *ngIf="isactiveinsurebutton" [routerLink]="['/comment-History',this.intimationNo]"></button>
              <!-- <span class="Path-8998"></span> -->

            <!-- <p class="date1">{{this.dateByinsurer | date: 'dd/MM/yyyy'}}</p> -->
          </li>
          <li class="StepProgress-item" [ngClass]="{'is-done' : isgetdocument}"><strong>{{ IntialDocumentSubmitted }}</strong>
            <p class="date1">{{this.documentsdDate | date: 'dd/MM/yyyy'}}</p>

           
              <!-- <p class="date1">{{this.documentsdDate | date: 'dd/MM/yyyy'}}</p> -->

          </li>


        <div *ngIf="ispendingforendorsement" class="StepProgress-item is-done">
          <li class="StepProgress-item" [ngClass]="{'is-done' : ispendingforendorsement}"><strong>{{ pendingforendorsement }}</strong>
            <p class="date1">{{this.dateByPendingEndorsement | date: 'dd/MM/yyyy'}}</p>
          </li>

        </div>

          <li class="StepProgress-item" [ngClass]="{'is-done' : isoutstanding}"><strong>{{ ClaimUnderProcess }}</strong>

            <button type="button" class="Path-8998 btn btn-primary" *ngIf="isactivedocumentbutton" [routerLink]="['/comment',this.intimationNo]"></button>
          
          <ul class="ite2 StepProgress">
            
            <li class="StepProgress-item" [ngClass]="{'is-done' : underRegistration}"><strong>{{ "Under registration with insurer" }}</strong>
              <p class="date1">{{this.underRegistrationDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : underMedical}"><strong>{{ "Under Medical Scrutiny(Fresh Claim)" }}</strong>
              <p class="date1">{{this.underMedicalDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : underMedicalAfterQuery}"><strong>{{ "Under Medical Scrutiny(After query reply)" }}</strong>
              <p class="date1">{{this.underMedicalAfterQueryDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : underAudit}"><strong>{{ "Under Audit" }}</strong>
              <p class="date1">{{this.underAuditDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : underInvestigation}"><strong>{{ "Under Investigation/Survey" }}</strong>
              <p class="date1">{{this.underInvestigationDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : underClaimRepresentation}"><strong>{{ "Under Claim Representation"}}</strong>
              <p class="date1">{{underClaimRepresentationDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : underQueryDocuments}"><strong>{{ "Under Query" }}</strong>
              <p class="date1">{{this.underQueryDocumentsDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : reopeningApproval}"><strong>{{ "Reopening approval requested from insurer" }}</strong>
              <p class="date1">{{this.reopeningApprovalDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : delayApproval}"><strong>{{ "Referred to Insurer for Delay intimation/submission approval" }}</strong>
              <p class="date1">{{this.delayApprovalDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : partialClaim}"><strong>{{ "Partial Claim" }}</strong>
              <p class="date1">{{this.partialClaimDate | date: 'dd/MM/yyyy'}}</p>
            </li>
            <li class="StepProgress-item" [ngClass]="{'is-done' : claimApproved}"><strong>{{ "Claim approved/Ready for Payment" }}</strong>
              <p class="date1">{{this.claimApprovedDate | date: 'dd/MM/yyyy'}}</p>
            </li>

        
        
       
           

          </ul>
          
          
          </li>
          
          <li class="StepProgress-item" [ngClass]="{'is-done' : finalStatus}"><strong class="amount_get">{{this.finalStatusName}}</strong>

            <button type="button" class="Path-8998 btn btn-primary" *ngIf="finalStatus" [routerLink]="['/Paid',this.intimationNo]"></button>
            <p class="date1">{{this.finalStatusDate | date: 'dd/MM/yyyy'}}</p>
          <div *ngIf="finalStatus">
          <span>{{this.getamounts}}</span>
        </div>

        <!-- <div *ngIf="this.showpaid">
          <div class="col-6" *ngIf="this.approvedAmount">
            <div class="row cardFields">Approved Amount</div>
            <div class="approv_amount" >Amount :-{{this.approvedAmount}}</div>
          </div>

        </div>
          
          <span class="comment_amount">{{claimstatuscomment}}</span> -->
          
          
          
          </li>
        </ul>

        <!-- <button type="button" [disabled]="!isactivedocumentbutton" class="btn btn-primary comment_hist" [routerLink]="[ '/Viewcomment',this.intimationNo]">View Comment History</button> -->

        </div>

        </div>
    </div>
  </section>

  <br>

<section class="aboutUs aboutUs1">
<div class="row">
<div class="container page_status">
  
  <div class="col-md-auto">
    <div class="page_progress page_progress2">
    <!-- details -->
    <div class="border rounded claimCards pt-2 content-box" id="checkStatusDetails">
      <p class="title ">Claim Details</p>
      <div class="row">
        <!-- <div class="col-6">
          <div class="row cardFields">Claim Status</div>
          <div class="row cardFieldsVal"><b>{{this.status}}</b></div>
        </div> -->
        <!-- <div class="col-6">
          <div class="row cardFields">Amount Claimed</div>
          <div class="row cardFieldsVal">{{this.estimatedAmount}}</div>
        </div> -->
      </div>
      <div class="row mt-4" *ngIf="this.claimStage || this.approvedAmount">
        <!-- <div class="col-6">
          <span class="row cardFields">Claim Stage</span>
          <span class="row cardFieldsVal"><b>{{this.claimStage}}</b></span>
        </div> -->
        <div class="col-6" *ngIf="this.approvedAmount">
          <div class="row cardFields">Approved Amount</div>
          <div class="row cardFieldsVal" >{{this.approvedAmount}}</div>
        </div>
        
        <div class="col-6">
          <div class="row cardFields">Amount Claimed</div>
          <div class="row cardFieldsVal">{{this.estimatedAmount}}</div>
        </div>
      </div>
      <!-- expanded -->
      <!-- <div id="viewMoreEclaimsData" hidden> -->
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">Policy No.</div>
            <div class="row cardFieldsVal">{{this.policyNumber}}</div>
          </div>
          <div class="col-6">
            <div class="row cardFields">Card No.</div>
            <div class="row cardFieldsVal">{{this.cardNumber}}</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <span class="row cardFields">Intimation No.</span>
            <span class="row cardFieldsVal">{{this.intimationNumber}}</span>
          </div>
          <!-- <div class="col-6" *ngIf="this.claimNoByInsurer">
            <span class="row cardFields" >Claim No.</span>
            <span class="row cardFieldsVal">{{this.claimNoByInsurer}}</span>
          </div> -->
        </div>
        <div class="spacer"></div>
       <!-- <button type="button" class="btn btn-outline-secondary btn-sm btn-block title" (click)="btnClick();" [routerLink]="['/progress',this.intimationNumber]">Check claim history</button> -->
        <p class="title mt-4 ">Patient Details</p>
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">Patient Name</div>
          <div class="row cardFieldsVal">{{this.claimant}}</div>
          </div>
          <div class="col-6">
            <div class="row cardFields">Claimant Name</div>
            <div class="row cardFieldsVal">{{this.employeeName}}</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">Relation</div>
            <div class="row cardFieldsVal">{{this.relationWithEmployee}}</div>
          </div>
        </div>
        <div class="spacer"></div>
        <p class="title mt-4 ">Hospital Details</p>
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">Treatment For</div>
            <div class="row cardFieldsVal">{{this.ailment}}</div>
          </div>
          <div class="col-6">
            <div class="row cardFields">Admission Date</div>
            <div class="row cardFieldsVal">{{this.admissionDate}}</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">Discharge Date</div>
            <div class="row cardFieldsVal">{{this.dischargeDate}}</div>
          </div>
          <div class="col-6">
            <div class="row cardFields">Hospital Name</div>
            <div class="row cardFieldsVal">{{this.hospitalName}}</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">City</div>
            <div class="row cardFieldsVal">{{this.hospitalCity}}</div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <!-- details -->

    </div>
  </div>
  </div>

</div>

  </section>


  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
  

